import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-title-underline" }, "すべての閲覧履歴", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" }
const _hoisted_5 = { class: "flex items-center justify-center mt-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 閲覧履歴はありませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_list_date_range_picker = _resolveComponent("video-list-date-range-picker")!
  const _component_video_thumbnail = _resolveComponent("video-thumbnail")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_video_list_date_range_picker, {
                startDate: _ctx.startDate,
                "onUpdate:startDate": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                endDate: _ctx.endDate,
                "onUpdate:endDate": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event))
              }, null, 8, ["startDate", "endDate"])
            ]),
            (_ctx.toArray(_ctx.watchHistories).length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList, (watchHistory) => {
                      return (_openBlock(), _createElementBlock("div", { key: watchHistory }, [
                        (watchHistory.video)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/video/${watchHistory.video.id}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_video_thumbnail, {
                                  video: watchHistory.video
                                }, null, 8, ["video"])
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_base_pagination, {
                      pagedList: _ctx.pagedList,
                      "onUpdate:pagedList": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagedList) = $event)),
                      originalList: _ctx.watchHistories,
                      pageSize: _ctx.pageSize
                    }, null, 8, ["pagedList", "originalList", "pageSize"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_6
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}